module.exports = __webpack_public_path__ + "static/img/confirmBg.0041cd2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dailyFreeCash/confirmBg.webp
// module id = 5zpN
// module chunks = 0